import { render } from "./BaseModal.vue?vue&type=template&id=1a8f44da"
import script from "./BaseModal.vue?vue&type=script&lang=ts"
export * from "./BaseModal.vue?vue&type=script&lang=ts"
script.render = render

export default script